import React from "react";
import {connect} from "react-redux";
import {WebcastStateEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import BidderRoundStopInfoCmp from "./BidderRoundStopInfoCmp";
import BidderRoundBiddingCmp, { TotalBid } from "./BidderRoundBiddingCmp";
import BidderRoundChoiceLotsSelectCmp from "./BidderRoundChoiceLotsSelectCmp";
import {useTranslation} from "react-i18next";
import {ReduxWebcastStatusType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastStatus";
import AuctionsManager from "@nextlot/core/webcast/services/AuctionsManager";
import {ReduxWebcastCurrentRoundType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRound";
import {ReduxWebcastCurrentRoundBiddingType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastCurrentRoundBidding";
import {ReduxWebcastAuctionDataType} from "@nextlot/core/webcast/redux/webcast/reducerWebcastAuctionData";
import {ReduxActiveWebcastSubStateType} from "@nextlot/core/webcast/redux/reducerActiveWebcast";
import BidderBidHistoryCmp from "./BidderBidHistoryCmp";
import { CurrencyAmountDisplay } from "../CurrencyAmountDisplay";


type RootCmpPropsType = {
    webcastStatus: ReduxWebcastStatusType,
    currentRound: ReduxWebcastCurrentRoundType,
    currentRoundBidding: ReduxWebcastCurrentRoundBiddingType,
    auctionData: ReduxWebcastAuctionDataType,
};

function renderPauseOverlay(paused: boolean, t) {
    if (! paused) {
        return null;
    }

    return (
        <div className="overlay-busy">
            <h3>{t('biddingArea.auctionPaused')}</h3>
        </div>
    )
}

function renderContent(props: RootCmpPropsType, t) {
    const webcastState: number = props.webcastStatus.state;
    const currentUserIsViewer: boolean = AuctionsManager.currentWebcastAuctionHandler.auctionConnectData.participantRole !== 'bidder';

    if (currentUserIsViewer) {
        return (
            <>
              <div className="d-flex flex-column flex-grow-1">
                  <a className="w-100 p-3 h4 btn btn-lg btn-bid" href={`${location.origin}/bidder/start`} rel="noopener noreferrer">
                      {t('biddingArea.registerLogin')}
                      {props.currentRoundBidding.askingBidValue > 0 && <CurrencyAmountDisplay valueCents={props.currentRoundBidding.askingBidValue}/>}
                  </a>
                  {
                      webcastState === WebcastStateEnum.WEBCAST_STATE__DURING_ROUND_BIDDING &&
                      <>
                        <div className="pb-2">
                            <TotalBid
                                currentRound={props.currentRound}
                                currentRoundBidding={props.currentRoundBidding}
                                auctionDataLotsById={props.auctionData.lotsMapById}
                                t={t}
                            />
                        </div>
                        <BidderBidHistoryCmp
                            t={t}
                        />
                      </>
                  }
              </div>

            </>

        )
    }


    switch (webcastState) {
        case WebcastStateEnum.WEBCAST_STATE__ROUND_STOPPING_TRANSITIONAL: {
            // round is stopping
            return <BidderRoundStopInfoCmp />
        }
        case WebcastStateEnum.WEBCAST_STATE__DURING_ROUND_BIDDING: {
            return <BidderRoundBiddingCmp
                currentRound={props.currentRound}
                currentRoundBidding={props.currentRoundBidding}
                auctionDataLotsById={props.auctionData.lotsMapById}
            />
        }
        case WebcastStateEnum.WEBCAST_STATE__CHOICE_ROUND_LOTS_SELECT: {
            // Choice round: select lots
            return <BidderRoundChoiceLotsSelectCmp
                currentRound={props.currentRound}
                currentRoundBidding={props.currentRoundBidding}
                auctionDataLotsById={props.auctionData.lotsMapById}
            />
        }

        case WebcastStateEnum.WEBCAST_STATE__LOADING:
        case WebcastStateEnum.WEBCAST_STATE__LOBBY: {
            return (
                <div className="d-flex flex-column flex-grow-1">
                    <button
                        type="button"
                        disabled={true}
                        className="p-3 btn-lg btn-block btn-bid bid-button--disabled"
                    >{t('biddingArea.waitingAuctionToStart')}</button>
                </div>
            )
        }

        default: {
            // BETWEEN_ROUNDS: no asking bid, and no bids placed
            // => we're about to start the round
            return (
                <div className="d-flex flex-column flex-grow-1">
                    <button
                        type="button"
                        disabled={true}
                        className="p-3 btn-lg btn-block btn-bid bid-button--disabled"
                    >{t('biddingArea.waitingBiddingToStart')}
                    </button>
                </div>
            )
        }
    }

}

function BidderBiddingAreaLayoutRootCmp(props) {

    const { t, i18n } = useTranslation();

    return (
        <div className="bidder-bidding-area-wrapper">
            {renderPauseOverlay(props.webcastStatus.paused, t)}
            {renderContent(props, t)}
        </div>
    )
}

export default connect(({activeWebcast}: { activeWebcast: ReduxActiveWebcastSubStateType }) => {
    return {
        webcastStatus: activeWebcast.webcastStatus,
        currentRound: activeWebcast.webcastCurrentRound,
        currentRoundBidding: activeWebcast.webcastCurrentRoundBidding,
        auctionData: activeWebcast.webcastAuctionData,
    };
})(BidderBiddingAreaLayoutRootCmp);


// type RootCmpPropsType = {
//     webcastStatus: ReduxWebcastStatusType,
//     currentRound: ReduxWebcastCurrentRoundType,
//     currentRoundBidding: ReduxWebcastCurrentRoundBiddingType,
// };
//
// function renderContent(props:RootCmpPropsType, t) {
//     const webcastState: number = props.webcastStatus.state;
//
//     switch (webcastState) {
//         case WebcastStateEnum.WEBCAST_STATE__ROUND_STOPPING_TRANSITIONAL: {
//             // round is stopping
//             return <BidderRoundStopInfoCmp />
//         }
//         case WebcastStateEnum.WEBCAST_STATE__DURING_ROUND_BIDDING: {
//             return <BidderRoundBiddingCmp
//                 currentRound={props.currentRound}
//                 currentRoundBidding={props.currentRoundBidding}
//                 saleDataLotsById={props.saleData.lotsMapById}
//             />
//         }
//         case WebcastStateEnum.WEBCAST_STATE__CHOICE_ROUND_LOTS_SELECT: {
//             // Choice round: select lots
//             return <BidderRoundChoiceLotsSelectCmp
//                 currentRound={props.currentRound}
//                 currentRoundBidding={props.currentRoundBidding}
//                 saleDataLotsById={props.saleData.lotsMapById}
//             />
//         }
//
//         case WebcastStateEnum.WEBCAST_STATE__LOADING:
//         case WebcastStateEnum.WEBCAST_STATE__LOBBY: {
//             return (
//                 <div className="d-flex flex-column flex-grow-1">
//                     <button
//                         type="button"
//                         disabled={true}
//                         className="p-3 btn-lg btn-block btn-bid bid-button--disabled"
//                     >{t('biddingArea.waitingAuctionToStart')}</button>
//                 </div>
//             )
//         }
//
//         default: {
//             // BETWEEN_ROUNDS: no asking bid, and no bids placed
//             // => we're about to start the round
//             return (
//                 <div className="d-flex flex-column flex-grow-1">
//                     <button
//                         type="button"
//                         disabled={true}
//                         className="p-3 btn-lg btn-block btn-bid bid-button--disabled"
//                     >{t('biddingArea.waitingBiddingToStart')}
//                     </button>
//                 </div>
//             )
//         }
//     }
// }
//
//
// function renderPauseOverlay(paused:boolean, t) {
//     if (! paused) {
//         return null;
//     }
//
//     return (
//         <div className="overlay-busy">
//             <h3>{t('biddingArea.auctionPaused')}</h3>
//         </div>
//     )
// }
//
//
// function BidderBiddingAreaLayoutRootCmp(props:RootCmpPropsType) {
//     const {t} = useTranslation();
//
//     return (
//         <div className="bidder-bidding-area-wrapper">
//             {renderPauseOverlay(props.webcastStatus.paused, t)}
//             {renderContent(props, t)}
//         </div>
//     )
// }
//
// export default connect(({activeWebcast}: { activeWebcast: ReduxActiveWebcastSubStateType }) => {
//     return {
//         webcastStatus: activeWebcast.webcastStatus,
//         currentRound: activeWebcast.webcastCurrentRound,
//         currentRoundBidding: activeWebcast.webcastCurrentRoundBidding,
//         saleData: activeWebcast.webcastAuctionData,
//     };
// })(BidderBiddingAreaLayoutRootCmp);
